// extracted by mini-css-extract-plugin
export default {"carbIconContainer":"CarbIcon_carbIconContainer__mn7Vh"};